import { EC_ORDER_ID, toEver, sanitizeEver } from "~/utils/evercookieCodec";

const YM_COUNTER_ID = 67027888;

export default ({ app, store, $axios, $gtm }, inject) => {
    inject("gtm", {
        push(data) {
            console.log(`$gtm dummy ${data.event}`);
        },
    });
    inject("grom", {
        checkEverCookie() {
            window.ec.get(EC_ORDER_ID, async function (cid) {
                let id = sanitizeEver(cid);
                if (id) {
                    // проверяем наличие id в базе, и если нет, разрешаем показывать
                    const { data } = await $axios(`/api/user-has-order/${id}`);
                    console.log(`device has orders ${data}`);
                    store.commit("globalvars/setUserHasOrders", data);
                } else {
                    // битое/отсутствует -> свежий uuid в base64 перезапишет все хранилища (самолечение)
                    id = window.crypto.randomUUID();
                    await window.ec.set(EC_ORDER_ID, toEver(id));
                }

                if (app.$auth.loggedIn) {
                    $axios("/api/user/orders").then((res) => {
                        const hasOrders = !!res.data.data.orders.length;
                        store.commit("globalvars/setUserHasOrders", hasOrders);
                        if (hasOrders) {
                            $axios.post(`/api/user-has-order/${id}`);
                        } else {
                            $axios.delete(`/api/user-has-order/${id}`);
                        }
                    });
                }
            });
        },

        removeEvercookieFromServer() {
            window.ec.get(EC_ORDER_ID, async function (cid) {
                const id = sanitizeEver(cid);
                if (id) {
                    $axios.delete(`/api/user-has-order/${id}`);
                }
            });
        },

        validateEmail(email) {
            const re =
                /^\s*(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;
            return re.test(String(email).toLowerCase());
        },
        removeSoldItems(items) {
            let isArray = Array.isArray(items);
            let res = [];
            for (const itemId in items) {
                if (Object.hasOwnProperty.call(items, itemId)) {
                    const element = items[itemId];
                    if (isArray && this.checkExisting(element)) {
                        res.push(element);
                    }
                    if (!isArray && !this.checkExisting(element)) {
                        delete items[itemId];
                    }
                }
            }

            return isArray ? res : items;
        },
        checkExisting(product) {
            let count = 0;
            let sku = product.product.skus.filter((sku) => sku.color_id == product.color.id)[0];
            if (sku) {
                for (let index = 0, len = sku.sizes.length; index < len; index++) {
                    count += 1;
                }
            }
            return count;
        },
        pushGTMshowProducts(products) {
            console.log(`gtm dummy pushGTMshowProducts`);
            // let productsArr = [];
            // Object.values(products).forEach((product, index) => {
            //     let color_sizes = product.product.skus.filter((el) => el.color_id == product.color.id);
            //     let in_stock_item =
            //         color_sizes.length > 0 ? color_sizes[0].sizes.filter((el) => el.in_stock > 0)[0] : false;

            //     productsArr.push({
            //         name: product.product.name,
            //         id: in_stock_item ? in_stock_item.sku_id.toString() : product.id.toString(),
            //         price: product.discount_price ? product.discount_price.toFixed(2) : product.price.toFixed(2),
            //         brand: "post-post-scriptum",
            //         category: product.product.category ? product.product.category.name : "", // Название категории (желательно - наиболее узкой)
            //         variant: `${in_stock_item ? in_stock_item.name : product.size.name} ${product.color.name}`, // Размер, цвет
            //         list: product.product.collection?.name || "Без коллекции",
            //         position: index + 1, // Позиция товара, считая от левого верхнего угла.           СТРОГО со значения 1.
            //     });
            // });
            // $gtm.push({
            //     event: "showProducts",
            //     ecommerce: {
            //         currencyCode: store.getters["globalvars/getCurrencyCode"],
            //         impressions: productsArr,
            //     },
            // });
        },
        processError(err, form) {
            let flatForm = {};
            for (const key in form) {
                if (Object.hasOwnProperty.call(form, key)) {
                    const element = form[key];
                    if (element.hasChilds) {
                        for (const childKey in element.childs) {
                            if (Object.hasOwnProperty.call(element.childs, childKey)) {
                                flatForm[childKey] = { key: childKey, isChild: true, parentKey: key };
                            }
                        }
                    } else {
                        flatForm[key] = { key: key, isChild: false };
                    }
                }
            }
            if (err.response) {
                if (err.response.status == 406) {
                    let notValidFields = err.response.data.data;
                    for (const key in notValidFields) {
                        if (notValidFields.hasOwnProperty(key)) {
                            const element = notValidFields[key];
                            let name = key.split(".").length > 1 ? key.split(".")[1] : key;
                            if (flatForm[name]?.isChild) {
                                let el = form[flatForm[name].parentKey].childs[name];
                                el.isValid = false;
                                el.validationMessage = element[0];
                            } else {
                                form[name].isValid = false;
                                form[name].validationMessage = element[0];
                            }
                        }
                    }
                    let first_key = Object.keys(notValidFields)[0];
                    let first_name = first_key.split(".").length > 1 ? first_key.split(".")[1] : first_key;
                    let elem = document.querySelector(`[name="${first_name}"]`);
                    if (elem) {
                        elem.scrollIntoView({ block: "center", behavior: "smooth" });
                        elem.focus();
                    }
                }
            }
        },
        getPostParamsAndResetValidation(form) {
            let res = {};
            for (const name in form) {
                if (Object.hasOwnProperty.call(form, name)) {
                    const element = form[name];
                    if (element) {
                        if (element.hasChilds) {
                            for (const childName in element.childs) {
                                if (Object.hasOwnProperty.call(element.childs, childName)) {
                                    const child = element.childs[childName];
                                    child.isValid = true;
                                    child.validationMessage = "";
                                    res[childName] = child.value;
                                }
                            }
                        } else {
                            element.isValid = true;
                            element.validationMessage = "";
                            res[name] = element.value;
                        }
                    }
                }
            }
            return res;
        },
        // Яндекс.Метрика: достижение цели (JS-событие)
        // goalName — идентификатор цели, params — параметры цели (объект)
        reachGoal(goalName, params) {
            try {
                if (process.client && typeof window.ym === "function") {
                    window.ym(YM_COUNTER_ID, "reachGoal", goalName, params || {});
                } else if (process.client) {
                    // счётчик грузится асинхронно через GTM — вызов до его готовности будет потерян
                    console.log(`ym not ready, goal skipped =>`, goalName);
                }
            } catch (e) {
                console.log(`e reachGoal =>`, e);
            }
        },
        reachEcommerce(actionType, data) {
            try {
                if (process.client) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        ecommerce: {
                            currencyCode: "RUB",
                            [actionType]: data,
                        },
                    });
                }
            } catch (e) {
                console.log(`e reachEcommerce =>`, e);
            }
        },
        objToParams(obj) {
            const params = new URLSearchParams();

            for (const key in obj) {
                const item = obj[key];

                if (item === null || item === undefined || item === "") {
                    continue;
                }

                if (Array.isArray(item)) {
                    item.forEach((value) => {
                        params.append(`${key}[]`, value);
                    });
                } else if (typeof item === "object") {
                    Object.keys(item).forEach((subKey) => {
                        params.append(`${key}[${subKey}]`, item[subKey]);
                    });
                } else {
                    params.append(key, item);
                }
            }

            return params.toString();
        },
    });
};
